<template>
  <div v-show="loading" id="preloader">
    <i-spinner size="xl"></i-spinner>
  </div>
</template>

<script>
import { iSpinner } from '@inscribe/signal';

export default {
  components: { iSpinner },
  data() {
    return {
      loading: true,
      listener: null,
    };
  },
  mounted() {
    this.emitter.on('preloader.on', () => {
      this.loading = true;
      const preloader = document.getElementById('preloader');
      this.listener = preloader.addEventListener('wheel', function (e) {
        e.preventDefault();
      });
    });
    this.emitter.on('preloader.off', () => {
      this.loading = false;
      const preloader = document.getElementById('preloader');
      preloader.removeEventListener('wheel', this.listener);
    });
  },
};
</script>

<style>
#preloader {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-top: 30px;
  text-align: center;
  font-family: 'PT Sans Narrow', sans-serif;
  font-size: 2em;
  cursor: not-allowed;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.79);
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
